export default __webpack_public_path__ + "static/media/IMG-20200716-WA0026.785f118b.jpg";